import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_FAILURE
} from '../constants'

export function* getBranchOfficesDataMasterSaga({data: { carLotId, branchOfficeId }}) {
  try {

    if(carLotId){

      const result =  yield call(BFFAgent.Datamasters.getBranchOffices, carLotId)
      const branchOfficesList = result?.data?.data
      let branchOfficeDefault = branchOfficeId && branchOfficesList.filter((option) => option.id === branchOfficeId)[0]
  
      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_SUCCESS,
          data: { branchOfficesList, branchOfficeDefault}
      })
      
  } else {

    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_FAILURE,
      data: { error: 'Se necesita el Id de la marca' }
    })
    
  }
}
    catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_BRANCH_OFFICES_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
